module.exports = __webpack_public_path__ + "static/updated-why-2-12d293863b02cb1876adf0bf41e09251.svg";